export class DispatchGroup {

    id: number;
    title: string;
    icon: string;
    created: string;

    constructor(id: number, title: string, icon: string, created: string) {
        this.id = id;
        this.title = title;
        this.icon = icon;
        this.created = created;
    }
}

export class DispatchGroupCreate {

    id: number;
    title: string;
    icon: string;
    created: string;

    constructor(title: string, icon: string) {
        this.title = title;
        this.icon = icon;
    }
}

